import createPersistedReducer from '../lib/createPersistedReducer';

const initialState = {
  members: {}
};

const persistConfig = {
  key: 'presenceReducer',
  whitelist: [],
  transforms: []
};

export default createPersistedReducer(
  initialState,
  {
    SET_MEMBERS: (state, payload) => ({ ...state, members: payload }),
    ADD_MEMBER: (state, payload) => ({
      ...state,
      members: { ...state.members, [payload.id]: payload.info }
    }),
    REMOVE_MEMBER: (state, payload) => {
      const { [payload]: removed, ...rest } = { ...state.members };
      return { ...state, members: rest };
    },
    FLUSH_MEMBERS: (state, payload) => ({ ...state, members: {} })
  },
  persistConfig
);
